import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import "./assets/styles/global.css";
import App from "./App";
import ReduxProvider from "./redux/provider";
import { BrowserRouter } from "react-router-dom";
import { Toaster } from "react-hot-toast";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <ReduxProvider>
        <Toaster
          position="top-right"
          reverseOrder={false}
          containerStyle={{
            top: 100,
            left: 20,
            bottom: 20,
            right: 50,
          }}
          toastOptions={{
            success: {
              style: {
                background: "rgba(0, 0, 0, 50%)",
                color: "white",
              },
            },
            error: {
              style: {
                background: "rgba(0, 0, 0, 50%)",
                color: "white",
              },
            },
          }}
        />
        <App />
      </ReduxProvider>
    </BrowserRouter>
  </React.StrictMode>
);
